<template>
  <Dialog :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" :title="$t('payment.tip')" :showClose="false" :maskClosable="false">
    <div class="act-time-dialog" :class="cssType">
      {{ $t('accum.actEnded') }}
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '@/components/Dialog/ActPoolParty/index.vue'
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})


</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>